<!--
 * @Descripttion:
 * @Author: liang
 * @Date: 2021-04-20 11:15:47
 * @LastEditors: liang
 * @LastEditTime: 2025-05-30 15:56:25
-->
<template>
  <div id="video">
    <div class="returndiv">
      <i class="el-icon-arrow-left" @click="back"></i>
      <b class="name">{{title}}</b>
      <!-- <i class="el-icon-star-off"></i>
      <span style="font-size: 16px">收藏</span> -->
      <!-- <i class="el-icon-star-on"></i> -->
    </div>
    <div class="video" :class="isAddCourse?'':'isaddvideo'">
      <video-player
        class="vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
        @timeupdate = "onPlayerTimeupdate($event)"
      ></video-player>
      <div class="zj" v-if="isAddCourse">
        <div @click="openzj">
          <i class="el-icon-video-play"></i>
          <div>章节</div>
        </div>
      </div>
    </div>
    <el-drawer
      title="选择章节"
      :visible.sync="drawer"
      :modal='false'
      direction="ltr"
      :size="400"
    >
      <ul class="sltzj">
        <li v-for="item in courseList" :class="item.id==id?'on':''" :key="item.id" @click="seevideo(item)">{{item.teachingTitle}}</li>
      </ul>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: 'video',
  data () {
    return {
      drawer: false,
      videoHeight: '500px',
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选择的播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: '',
            src: '' // url地址
          }
        ],
        poster: '', // 你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true // 全屏按钮
        }
      },
      teachRate: 0,
      courseList: [],
      minioUrl: '',
      tid: '',
      tName: '',
      id: '',
      title: '',
      selectId: '',
      isComplete: null,
      complate80: 0,
      user: '',
      isAddCourse: false,
      skcount: 0
    }
  },
  components: {},
  computed: {
    player () {
      return this.$refs.videoPlayer.player
    }
  },
  methods: {
    openzj () {
      this.drawer = true
    },
    back () {
      if (!this.selectId) {
        this.$router.push({ path: '/myplan', query: { activeName: 'first' } })
      } else {
        this.$router.push({ path: '/detail', query: { selectId: this.selectId, tid: this.tid, tName: this.tName } })
      }
    },
    onPlayerTimeupdate (player) {
      this.teachRate = player.cache_.currentTime / player.cache_.duration
      // 3分钟试看
      // if (!this.isAddCourse) {
      //   if (player.cache_.currentTime > 180) {
      //     this.skcount = this.skcount + 1
      //     this.$refs.videoPlayer.player.pause()
      //     if (this.skcount === 1) {
      //       this.$alert('试看结束，想观看完整课程，请您登录并购买、加入课程！', '提示', {
      //         confirmButtonText: '确定',
      //         callback: action => {
      //           this.back()
      //         }
      //       })
      //     }
      //   }
      // } else {

      // }
      // 正式观看，加锚点，防止用户直接拖到最后去完成课程
      if (parseInt(this.teachRate * 100) === 80) {
        this.complate80 += 1
        if (this.complate80 === 1) {
          this.finish(parseInt(player.cache_.duration))
        }
      } else if (parseInt(this.teachRate * 100) === 84 || parseInt(this.teachRate * 100) === 90 || parseInt(this.teachRate * 100) === 91 || parseInt(this.teachRate * 100) === 92 || parseInt(this.teachRate * 100) === 93 || parseInt(this.teachRate * 100) === 94) {
        if (this.complate80 === 0) {
          this.complate80 += 1
          if (this.complate80 === 1) {
            this.finish(parseInt(player.cache_.duration))
          }
        }
      }
    },
    finish (alltime) {
      this.$post('/client/personalCenter/videoPlayback', { teachingInfoId: this.id, teachRate: '80', isComplete: '1', studyDuration: alltime - 0 }).then(res => {})
    },
    getCourse () {
      this.$get('/clientNotAuth/getCourseChaptersInfo', { id: this.tid, userId: this.user.id }).then(res => {
        if (res.code === 0) {
          this.courseList = res.data
        }
      })
    },
    seevideo (item) {
      this.$router.push({ path: '/video', query: { vurl: process.env.VUE_APP_alioss + item.teachingUrl, tid: this.tid, title: item.teachingTitle, selectId: this.selectId, id: item.id, tName: this.tName } })
      this.$refs.videoPlayer.player.src(process.env.VUE_APP_alioss + item.teachingUrl)
    }
  },
  mounted () {
    this.videoHeight = document.body.scrollHeight + 'px'
  },
  watch: {
    $route: {
      handler (to) {
        if (to.path === '/video') {
          this.complate80 = 0
          this.minioUrl = process.env.VUE_APP_minio
          this.id = this.$route.query.id || ''
          this.tid = this.$route.query.tid || ''
          this.tName = this.$route.query.tName || ''
          this.title = this.$route.query.title || ''
          this.selectId = this.$route.query.selectId || ''
          this.playerOptions.sources[0].src = this.$route.query.vurl
          this.user = JSON.parse(localStorage.getItem('user')) || ''
          this.getCourse()
          this.isAddCourse = this.$store.state.isAddCourse
          this.skcount = 0
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>
<style scoped>
.video.isaddvideo{padding-left: 0;}
.video {
  position: relative;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
  padding-left: 60px;
  padding-top: 60px;
}
div /deep/.video-player div > span,
div /deep/.video-player div > button,
div /deep/.video-player div .vjs-playback-rate-value,
div /deep/.video-player div .vjs-menu-item-text {
  color: #fff;
}
div /deep/.video-player div .vjs-menu li.vjs-selected .vjs-menu-item-text,
div /deep/.video-player div .vjs-menu li.vjs-selected:focus .vjs-menu-item-text,
div
  /deep/.video-player
  div
  .vjs-menu
  li.vjs-selected:hover
  .vjs-menu-item-text {
  color: #2b333f;
}
.returndiv {
  height: 60px;
  line-height: 60px;
  background: #fff;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  border-bottom: 1px solid #eee;
  z-index: 22;
  display: flex;
  align-items: center;
  font-size: 18px;
  padding-left: 20px;
  box-sizing: border-box;
}
.returndiv i {
  font-size: 30px;
  cursor: pointer;
  margin-right: 5px;
}
.returndiv i:hover {
  color: #409eff;
}
.returndiv .name {
  padding-right: 20px;
  padding-left: 10px;
}

.zj {
  position: fixed;
  left: 0;
  top: 60px;
  bottom: 0;
  width: 60px;
  z-index: 222;
  background: rgb(28, 31, 33);
  display: flex;
  align-items: center;
  justify-content: center;
}
.zj div {
  color: #fff;
  cursor: pointer;
}
.zj div i {
  font-size: 24px;
  margin-bottom: 4px;
}
.zj div:hover i,
.zj div:hover > div {
  color: #409eff;
}
.sltzj {
  padding: 20px 20px 0;
}
.sltzj li {
  cursor: pointer;
  font-size: 16px;
  width: 100%;
  margin-bottom: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sltzj li:hover ,.sltzj li.on{
  color: #409eff;
}
div /deep/.el-drawer__body {
  overflow-x: hidden;
  overflow-y: auto;
}
div /deep/.el-drawer__header {
  padding: 20px;
  margin: 0;
  border-bottom: 1px solid #eee;
}
div /deep/.vjs-progress-control{pointer-events:none}
</style>
